import { FormLabel, Grid, MenuItem, Select } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import api from "../../utils/api";
import { StringNumber, TSede } from "../../types";

export const SelectSede = ({
  value: _val,
  action
}: {
  value: StringNumber,
  action: any
}) => {

  const [sedes, setSedes] = useState<TSede[]>();
  const [sede, setSede] = useState<TSede>();

  const getSede = async () => {
    try {
      const req = await api.get('sede/geral');
      const res = req?.data;

      setSedes(res);
    } catch (error) {

    }
  }

  const selectSede = (value: StringNumber) => {
    let sedeSelected = sedes?.find((sed) => sed?.id == value);
    setSede(sedeSelected);
    action(sedeSelected?.id);
  }

  useMemo(() => {
    getSede()
  }, [])


  const Selecter = useCallback(
    () => {
      return (
        <Select
          defaultValue={_val}
          value={sede?.id}
          onChange={(event) => selectSede(event?.target?.value)}
        >
          {
            sedes?.map(sede =>
              <MenuItem value={sede?.id}>
                {sede?.nomefantasia}
              </MenuItem>
            )
          }
        </Select>
      )
    },
    [_val, sedes])

  return (
    <>
      <Grid item display={'grid'}>
        <FormLabel>Campus</FormLabel>
        <Selecter/>
      </Grid>
    </>
  )
}
